export default __webpack_public_path__ + "static/media/expl_gradcam_07_DE.e07b8740.png";